<template>
    <q-dialog ref="dialogRef" @hide="onDialogHide">
        <q-card class="q-dialog-plugin">
            <q-form @submit.prevent="update">
                <q-card-section>
                    <div class="text-h6">Удалить выбранные задачи</div>
                </q-card-section>
                <q-card-section>
                    <div>Вы уверены что хотите удалить выбранные задачи?</div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn :loading="copied" no-caps label="Удалить" type="submit" color="primary" />
                    <q-btn :disable="copied" color="primary" label="Отмена" no-caps @click="onDialogCancel" />
                </q-card-actions>
            </q-form>

        </q-card>
    </q-dialog>
</template>
<script setup lang="ts">
import { useDialogPluginComponent, useQuasar } from 'quasar'
import { useProjectLabels, useProjectUsers, useSelectProjects } from '../composables/project'
import { useAddTask, useAddTaskLabels, useAddTaskPerformers, useDeleteTask, useDeleteTasks, useTask, useTaskTypes } from '../composables/task'
import { computed, ref, toRefs, watch } from 'vue'
import { requiredRule, notEmptyRule } from "../util/rules";
import { NewTask } from '../models/task';
import { useDayJs } from '../composables/dayjs';
import { useRouteParams } from '@vueuse/router';
import { useRouter } from 'vue-router';
import { usePerformTask, useUpdatePerformTask } from '../composables/performTask';
import { UpdatePerformTask } from '../models/performTask';
import { useEventBus } from '@vueuse/core';
import { taskKey } from '../util/events';
const dayjs = useDayJs()
const projectId = useRouteParams('projectId', undefined, { transform: Number })
const taskEvent = useEventBus(taskKey)
const $q = useQuasar()
const props = withDefaults(defineProps<{
    tasks: number[],
    performTasks: number[]
}>(), { tasks: [] })

const { tasks } = toRefs(props)
const { execute } = useDeleteTasks(projectId, tasks)
defineEmits([
    // REQUIRED; need to specify some events that your
    // component will emit through useDialogPluginComponent()
    ...useDialogPluginComponent.emits
])

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const taskType = ref(null)
const copyTasks = ref(0)
const copied = ref(false)

const router = useRouter()
const properties = ref([])
async function update() {
    copied.value = true
    try {
        if (tasks.value.length > 0) {
            await execute(true)
        }
    } catch (e) {
        $q.notify({
            type: "negative",
            message: e,
            position: "top-right",
            actions: [
                {
                    noDismiss: false,
                    icon: "close",
                    color: "white"
                }
            ]
        })
    }
    taskEvent.emit('refresh')
    copied.value = false
    onDialogOK()
}
</script>